let searchBtn = document.querySelector('.search-btn')
let searchBar = document.querySelector('.search-bar')
const mainNav = document.querySelector('.nav-main ul')
const hamburger = document.querySelector('.hamburger')
const searchInput = document.querySelector('input#searchBar')

searchBtn?.addEventListener('click', (e) => {
  e.preventDefault()
  searchBar.classList.toggle('shown')
  mainNav.classList.remove('shown')
  hamburger.classList.remove('openned')
})

searchInput.addEventListener('keydown', e => {
  e.keyCode === 27 && searchBar.classList.remove('shown')
})

searchBar.addEventListener('transitionend', () => {
  searchInput.value = ''
  searchBar.classList.contains('shown') ? searchInput.focus() : searchInput.blur()
})
